// Generador de colores secuenciales para buses 🚌🎨

// Cache para que cada busId conserve su color
const busColorMap = {};
let colorIndex = 0;

// Paleta de colores vibrantes, alto contraste y sin amarillos/dorados
const vibrantColors = [
  "#EF4444", // Rojo
  "#3B82F6", // Azul
  "#8B5CF6", // Morado
  "#10B981", // Verde esmeralda
  "#F97316", // Naranja brillante
  "#06B6D4", // Cyan
  "#EC4899", // Rosa
  "#84CC16", // Verde lima
  "#6366F1", // Índigo
  "#14B8A6", // Teal / Turquesa
];

export function getBusColor(busId) {
  if (busColorMap[busId]) {
    return busColorMap[busId];
  }

  // Asignamos el color en orden. Si hay más de 10 buses, vuelve a empezar la lista.
  const color = vibrantColors[colorIndex % vibrantColors.length];
  colorIndex++;

  busColorMap[busId] = color;
  return color;
}